document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menuToggles = document.querySelectorAll('.menu-drawer__toggle');
  const submenuButtons = document.querySelectorAll('[data-submenu]');
  const closeSubmenuButtons = document.querySelectorAll('[data-close]');

  // Toggle main menu
  menuToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      body.classList.toggle('menu-drawer__active');
    });
  });

  // ESC key closes menu
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && body.classList.contains('menu-drawer__active')) {
      body.classList.remove('menu-drawer__active');
    }
  });

  // Open submenu
  submenuButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const submenuId = btn.getAttribute('data-submenu');
      document.getElementById(submenuId).classList.add('active');
    });
  });

  // Close submenu
  closeSubmenuButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const submenuId = btn.getAttribute('data-close');
      document.getElementById(submenuId).classList.remove('active');
    });
  });
});
